import { useEffect } from "react";
import {
  getCookieConsent,
  onCookieConsentChange,
  COOKIE_CONSENT_ACCEPTED,
} from "../lib/cookieConsent";

const POSTHOG_KEY = "phc_xAvL2Iq4tFmANRE7kzbKwaSqp1HJjN7x48s3vr0CMjs";
const POSTHOG_HOST = "https://us.i.posthog.com";

let loadedOnce = false;

/**
 * Lazily injects the PostHog snippet only after the user has accepted
 * non-essential cookies. We DO NOT load it on first paint , that would be a
 * PECR / UK GDPR breach for any EU/UK visitor (analytics + session recording
 * are non-essential cookies).
 *
 * If the user later changes their mind and rejects, we call posthog.opt_out
 * to stop further capture. (We can't fully un-load the SDK from the page in
 * one tick , a hard reload is the only way to remove it entirely.)
 */
export const PostHogLoader = () => {
  useEffect(() => {
    const inIframe = typeof window !== "undefined" && window.self !== window.top;
    if (inIframe) return; // skip inside Emergent preview iframe

    const apply = (choice) => {
      if (choice === COOKIE_CONSENT_ACCEPTED) {
        if (loadedOnce) {
          if (window.posthog && window.posthog.opt_in_capturing) {
            try { window.posthog.opt_in_capturing(); } catch (_) {}
          }
          return;
        }
        loadedOnce = true;
        // Bootstrap the official PostHog snippet (same as their docs).
        /* eslint-disable */
        !(function (t, e) {
          var o, n, p, r;
          e.__SV ||
            ((window.posthog = e),
            (e._i = []),
            (e.init = function (i, s, a) {
              function g(t, e) {
                var o = e.split(".");
                2 == o.length && ((t = t[o[0]]), (e = o[1])),
                  (t[e] = function () {
                    t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
                  });
              }
              ((p = t.createElement("script")).type = "text/javascript"),
                (p.crossOrigin = "anonymous"),
                (p.async = !0),
                (p.src = s.api_host.replace(".i.posthog.com", "-assets.i.posthog.com") + "/static/array.js"),
                (r = t.getElementsByTagName("script")[0]).parentNode.insertBefore(p, r);
              var u = e;
              for (
                void 0 !== a ? (u = e[a] = []) : (a = "posthog"),
                  u.people = u.people || [],
                  u.toString = function (t) {
                    var e = "posthog";
                    return "posthog" !== a && (e += "." + a), t || (e += " (stub)"), e;
                  },
                  u.people.toString = function () { return u.toString(1) + ".people (stub)"; },
                  o = "init capture identify reset opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing register register_once unregister".split(" "),
                  n = 0;
                n < o.length;
                n++
              )
                g(u, o[n]);
              e._i.push([i, s, a]);
            }),
            (e.__SV = 1));
        })(document, window.posthog || []);
        window.posthog.init(POSTHOG_KEY, {
          api_host: POSTHOG_HOST,
          person_profiles: "identified_only",
          session_recording: { recordCrossOriginIframes: true },
        });
        /* eslint-enable */
      } else {
        if (loadedOnce && window.posthog && window.posthog.opt_out_capturing) {
          try { window.posthog.opt_out_capturing(); } catch (_) {}
        }
      }
    };

    // 1) Apply whatever choice is already on file.
    apply(getCookieConsent());

    // 2) React to future changes from the banner / cookie page.
    const off = onCookieConsentChange(apply);
    return off;
  }, []);

  return null;
};

export default PostHogLoader;
